<template>
  <Search />
  <Table />
</template>
<script>
import {
  language_list_get,
  language_enable_post,
  common_info_get
} from 'server/modules/351.js'
import { provide, onMounted, reactive, toRefs } from 'vue'
import Search from './components/Search'
import Table from './components/Table'
import { message } from 'ant-design-vue'
export default {
  components: {
    Search,
    Table
  },
  setup() {
    // const store = useStore()
    const state = reactive({
      total: 0,
      pageNum: 1,
      pageSize: 10,
      lang: [],
      params: {
        langEn: null,
        langCn: null,
        enabled: null
      },
      dataList: [],
      // 修改页码
      changePage: pageNum => {
        state.pageNum = pageNum
        state.getList()
      },
      onShowSizeChange(current, pageSize) {
        state.pageNum = current
        state.pageSize = pageSize
        state.getList()
      },

      /**
       * 查询地址列表
       */
      getList: async () => {
        const { data, retCode, retInfo } = await language_list_get({
          ...state.params,
          ...{
            pageNum: state.pageNum,
            pageSize: state.pageSize
          }
        })
        if (retCode === '000000') {
          const { list, total } = data
          state.dataList = list
          state.total = total
        } else {
          message.error(retInfo)
        }
      },
      getCommonInfo: async () => {
        const { success, data } = await common_info_get().catch(() => {})
        if (success) {
          state.lang = data.lang
        }
      },
      /**
       * 是否启用开关
       */
      async updateSwitch(text) {
        const { data, retInfo, success } = await language_enable_post({
          id: text.id,
          enabled: text.enabled
        })
        if (success) {
          message.success(data)
        } else {
          message.error(retInfo)
        }
      }
    })

    onMounted(() => {
      const { getList, getCommonInfo } = state
      getCommonInfo()
      getList()
    })
    provide('state', state)

    return {
      ...toRefs(state)
    }
  }
}
</script>
